module.exports = __webpack_public_path__ + "static/media/teamphoto_elliot2.e9d832f3.png";